__turbopack_context__.v({
  "footer": "Footer-module__rnk_JG__footer",
  "logo": "Footer-module__rnk_JG__logo",
  "text": "Footer-module__rnk_JG__text",
});
